import { render, staticRenderFns } from "./LessonButton.vue?vue&type=template&id=71caa2d6&scoped=true&"
import script from "./LessonButton.vue?vue&type=script&lang=ts&"
export * from "./LessonButton.vue?vue&type=script&lang=ts&"
import style0 from "./LessonButton.vue?vue&type=style&index=0&id=71caa2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71caa2d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('71caa2d6', component.options)
    } else {
      api.reload('71caa2d6', component.options)
    }
    module.hot.accept("./LessonButton.vue?vue&type=template&id=71caa2d6&scoped=true&", function () {
      api.rerender('71caa2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/LessonButton.vue"
export default component.exports